import { DateTime } from 'luxon'
import type { ReactElement } from 'react'

export interface RelativeTimeProps {
  time: string | null
  includeWeekday?: boolean
  shouldCapitalize?: boolean
  excludeTime?: boolean
}

// This builds off <Time> to display times in a human-friendly way
// This is useful for forum comments.
export default function RelativeTime({
  time,
  includeWeekday = false,
  shouldCapitalize = true,
  excludeTime = false,
}: RelativeTimeProps): ReactElement | null {
  if (time == null) {
    return null
  }

  const dateTime = DateTime.fromISO(time)

  const today = DateTime.local()
  const isToday = dateTime.hasSame(today, 'day')
  const isYesterday = dateTime.plus({ days: 1 }).hasSame(today, 'day')
  const isCurrentYear = !!dateTime.hasSame(today, 'year')

  const dateFormat = `${includeWeekday ? 'EEE ' : ''}LLL d${isCurrentYear ? '' : ', y'}`
  const timeText = excludeTime ? '' : `, ${dateTime.toLocaleString(DateTime.TIME_SIMPLE)}`

  return (
    <time dateTime={time}>
      {isToday
        ? `${shouldCapitalize ? 'Today' : 'today'}${timeText}`
        : isYesterday
          ? `${shouldCapitalize ? 'Yesterday' : 'yesterday'}${timeText}`
          : `${dateTime.toFormat(dateFormat)}${timeText}`}
    </time>
  )
}
